import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormGroup, InputGroup } from '@blueprintjs/core';
import Row from 'containers/Reports/row';
import { runIndividualRequestReport } from 'actions/reports';
import clone from 'lodash/clone';

const transformDataForReport = report => {
  const newReport = clone(report);
  Object.defineProperty(newReport, 'score', {
    value: !!report.scoreResult.length
      ? JSON.stringify(
          report.scoreResult
            .map(res => `${res.typeName}: ${res.score}`)
            .join(' | ')
        ).replace(/"/g, '')
      : 'N/A',
  });

  Object.defineProperty(newReport, 'approvalDate', {
    value: !!report.vendorRequestResult[0]
      ? report.vendorRequestResult[0].approvalDate
      : 'N/A',
  });

  Object.defineProperty(newReport, 'questionsAnswered', {
    value: JSON.stringify(
      report.questionnaireResult
        .map(q => {
          const question = q.question;
          const answer = q.answers.find(a => q.selected.includes(a.answerID));
          if (answer) {
            return `Question: ${question} - Selected Answer: ${
              answer.answer
            } - Comment: ${q.note} `;
          } else {
            return ` Question: ${question} - Not answered - `;
          }
        })
        .join(' | ')
    ).replace(/[[\]"]+/g, ''),
  });

  return [newReport];
};
const IndividualRequestBase = ({
  runIndividualRequestReport,
  report,
  ...rest
}) => {
  const [vendorRequestID, setVendorRequestID] = useState('');
  return (
    <Row
      name={`Individual Assessment${vendorRequestID &&
        ` for ID ${vendorRequestID}`}`}
      description="All questions, answers, and comments for an assessment."
      drawer={
        <div style={{ width: '50%' }}>
          <FormGroup label="Assessment ID">
            <InputGroup
              value={vendorRequestID}
              onChange={({ target }) => setVendorRequestID(target.value)}
            />
          </FormGroup>
        </div>
      }
      runReport={() =>
        runIndividualRequestReport({
          vendorRequestID,
        })
      }
      data={transformDataForReport(report)}
      headers={[
        { label: 'Third Party Name', key: 'vendorRequestResult[0].vendorName' },
        {
          label: 'Assessment ID',
          key: 'vendorRequestResult[0].vendorRequestID',
        },
        { label: 'Status', key: 'vendorRequestResult[0].requestStatus' },
        { label: 'Approval Date', key: 'approvalDate' },
        { label: 'Scores', key: 'score' },
        { label: 'Questions Answered', key: 'questionsAnswered' },
      ]}
      resetDrawerState={() => {
        setVendorRequestID('');
      }}
      {...rest}
    />
  );
};
const mapStateToProps = state => ({
  report: state.reports.individualRequest,
  isFetchingReport: state.reports.isFetching,
  isLoadedReport: state.reports.isLoaded,
  errorMessage: state.reports.errorMessage,
});

const IndividualRequest = connect(
  mapStateToProps,
  { runIndividualRequestReport }
)(IndividualRequestBase);

export default IndividualRequest;
